const React = require("react");
function IconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m9.04545 16.0746-4.53409-4.388L3 13.1493 9.04545 19 22 6.46269 20.4886 5z"
  }));
}
module.exports = IconCheck;